import { TripsTable } from "@/features/trips/trips-table";

export function TripsListScreen() {
  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Trips</h1>
        <p className="text-gray-600 mt-2">Manage delivery routes</p>
      </div>
      <TripsTable />
    </div>
  );
}
